import { gql } from 'apollo-angular';

const GET_ORGANIZATION_NOTIFICATIONS = gql`
  query organization($id: Long!) {
    organization(id: $id) {
      id
      notifications {
        name
        displayName
        description
      }
    }
  }
`;

export default GET_ORGANIZATION_NOTIFICATIONS;
